import createVueComponent from '../createVueComponent';

const Rewind = createVueComponent('RewindIcon', [
  ['polygon', { points: '11 19 2 12 11 5 11 19' }],
  ['polygon', { points: '22 19 13 12 22 5 22 19' }],
]);

export default Rewind;
